export class BehaviorPreferences {
    Layout_ID: number;
   }